import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import Box from "../layouts/Box";
import Text from "../../atoms/text/";
import { themeComponent } from "../../../util/themeUtils";
import { fallbackValues } from "./Badge.theme";

const StyledBadgeContainer = styled(Box)`
  display: inline-flex;
  padding: 2px 8px;
  align-items: center;
  align-self: flex-start;
  gap: 4px;
  border-radius: 4px;
`;

const StyledBadge = styled(Text)`
  line-height: 150%;
  letter-spacing: ${props => (props.isMobile ? "0.2px" : "0.24px")};
  white-space: nowrap;
`;

const Badge = ({
  label,
  Icon,
  themeValues,
  iconOnLeft = true,
  id,
  extraStyles
}) => {
  const { isMobile } = useContext(ThemeContext);

  return (
    <StyledBadgeContainer
      background={themeValues.background}
      id={id}
      extraStyles={extraStyles}
    >
      {iconOnLeft && Icon && (
        <Icon color={themeValues.color} fill={themeValues.color} />
      )}
      <StyledBadge
        color={themeValues.color}
        weight={themeValues.fontWeight}
        fontSize={
          isMobile ? themeValues.fontSizeMobile : themeValues.fontSizeDesktop
        }
        isMobile={isMobile}
      >
        {label}
      </StyledBadge>
      {!iconOnLeft && Icon && (
        <Icon color={themeValues.color} fill={themeValues.color} />
      )}
    </StyledBadgeContainer>
  );
};

export default themeComponent(Badge, "Badge", fallbackValues, "success");
